import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import backBtn from '../back-btn.svg';
import closeBtn from '../close-btn.svg';
import { injectIntl } from 'react-intl';
import OemContactForm from '../../OemContactForm';
import { getMessages } from '../../../tppServices/translations/messages';


const ContactPage = ({
  intl,
  setDealerIndex,
  closeModal,
  dealer,
  listing,
  isWorking,
  postalCode,
  oemDetails,
  type,
  contactFormTitle
}) => {
  const { formatMessage: t } = intl;
  const messages = getMessages();
  const BackBtn = () => (
    <button className="back-btn" onClick={() => setDealerIndex(undefined)}>
      <img src={backBtn} />
      <span>{t(messages.dealerLocatorModal.backToDealerList)}</span>
    </button>
  );
  const CloseBtn = () => (
    <button className="close-btn" onClick={closeModal}>
      <img src={closeBtn} />
      <span className="visuallyhidden">Close Modal</span>
    </button>
  );

  const getTitle = (listing) => {
    return listing.year + ' ' + listing.make + ' ' + get(listing, 'model', '');
  };

  const prePopulatedText = (listing) => {
    return t(messages.dealerLocatorModal.contactPrepopulateText, {
      listingTitle: getTitle(listing)
    });
  };

  return (
    <>
      <header>
        <BackBtn />
        <CloseBtn />
      </header>
      <div className="oem-contact-form-from-dealer">
        <OemContactForm
          isLoading={isWorking}
          disableSticky={true}
          initialState="open"
          contact={dealer.contact}
          partyId={dealer.dealerId}
          prePopulatedText={prePopulatedText(listing)}
          type={type}
          proximity={dealer?.distance[0] + ' ' + dealer?.distance[1]}
          zipCode={postalCode}
          onSuccess={closeModal}
          id="oem-contact-form"
          oemDetails={oemDetails}
          listingId={listing.id}
          ownerId={listing?.owner?.id}
          listing={listing}
          contactFormTitle={contactFormTitle}
        />
      </div>
    </>
  );
};

ContactPage.propTypes = {
  setDealerIndex: PropTypes.any,
  closeModal: PropTypes.func,
  dealer: PropTypes.any,
  listing: PropTypes.any,
  isWorking: PropTypes.any,
  postalCode: PropTypes.any,
  oemDetails: PropTypes.any,
  type: PropTypes.any,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  contactFormTitle: PropTypes.string
};

export default injectIntl(ContactPage);
